import {State} from '../../Store';
import {Store} from 'vuex';
import {EditorPanelMutation, EditorPanelState} from '../../modules/editor/Panel';

export class EditorPanelStoreControllerClass {
	private _store!: Store<State>;

	private static _instance: EditorPanelStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelStoreControllerClass());
	}

	private constructor() {}

	set_store(store: Store<State>) {
		this._store = store;
	}

	// getters
	get local_state(): EditorPanelState {
		return (<unknown>(this._store.state.editor as any).panel) as EditorPanelState;
	}
	fullscreenPanelId(): string | null {
		return this.local_state.fullscreenPanelId;
	}

	// mutations
	setFullscreenPanelId(panelId: string | null): void {
		this._store.commit(`editor/panel/${EditorPanelMutation.FULLSCREEN_PANEL_ID}`, panelId);
		setTimeout(() => {
			window.dispatchEvent(new Event('resize'));
		}, 0);
	}
}

export const EditorPanelStoreController = EditorPanelStoreControllerClass.instance();
